import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CardBaseComponent } from '../card-base/card-base.component';
import { CardModel } from '../models/card.model';

@Component({
  selector: 'mb-card-row',
  templateUrl: './card-row.component.html',
  styleUrls: ['./card-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardBaseComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardRowComponent {
  @Input() alignContent!: string;
  @Input() data!: CardModel;
  @Input() fuelLabelPosition = 'default';
}
